import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";


export const socials = [
    {
        name: "Instagram",
        icon: FaInstagram,
        url: "https://www.instagram.com/netmax.redes/",
        color: "#ffff",
    },
    {
        name: "Facebook",
        icon: FaFacebookF,
        url: "https://www.facebook.com/people/Netmax/100066487674381/",
        color: "#ffff",
    },
    {
        name: "LinkedIn",
        icon: FaLinkedinIn,
        url: "https://www.linkedin.com/company/netmax-redes/about/",
        color: "#ffff",
    },
    {
        name: "WhatsApp",
        icon: FaWhatsapp,
        url: "https://wa.me/5493571458075",
        color: "#ffff",
    },
];
